import * as R from 'ramda'

import constants from 'config/constants'

// Event-based surveys are delivered over email and use a dedicated endpoint;
// every other survey type syncs a rating link tagged with the integration source.
export function buildSurveySelectorValue(survey) {
  if (!survey) {
    return null
  }

  const isEventBasedSurvey = (survey.type || '').includes('event_based')
  if (isEventBasedSurvey) {
    return `${constants.backendHost}/api/v1/surveys/${survey.token}/email/`
  }

  return `${constants.backendHost}/api/rating/${survey.token}/?source=${survey.type}`
}

// The stored value is a constructed URL that embeds the survey token. Match the
// survey back so the dropdown can show the current selection (also accepts a bare
// token for backward compatibility).
export function findSelectedSurvey(surveys, value) {
  if (!value) {
    return null
  }

  return (
    surveys.find((survey) => value === survey.token) ||
    surveys.find((survey) => survey.token && value.includes(survey.token)) ||
    null
  )
}

export function mapVariablesToDataSource(variable) {
  // Convert string 'null' or 'update me' (or a missing value) to actual null on initial load
  let normalizedValue = variable.Value
  if (
    normalizedValue === 'null' ||
    normalizedValue === 'update me' ||
    normalizedValue === undefined
  ) {
    normalizedValue = null
  }

  const fieldName = variable.Field?.Name
  const displayName = variable.DisplayName || fieldName
  const systemName = variable.SystemName || fieldName

  const addedProperties = {
    DisplayName: displayName,
    SystemName: systemName,
    Field: {
      DataType: 'Text',
      Name: displayName,
      Description: null,
      Triggers: [],
      IsOptional: false,
    },
    IsVariable: true,
  }
  // Merge variable into addedProperties (preserves original merge order)
  const merged = R.mergeDeepRight(addedProperties, variable)
  // Override Value with normalized value. Variables are always StaticValue, so
  // default it when the connector omits it (otherwise the field renders blank).
  return {
    ...merged,
    DisplayName: displayName,
    SystemName: systemName,
    Value: normalizedValue,
    MappingType: variable.MappingType || 'StaticValue',
  }
}

export function isVariableField(row) {
  return row?.IsVariable
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CyclrCustomFieldForm/Variables/utils.js